var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box, FormControl, FormLabel, Stack, Text, useRadio, useRadioGroup, } from "@chakra-ui/react";
import { capitalize } from "lodash";
import { FormLabelStyle } from "../../styles";
export const ToggleButtonGroup = (_a) => {
    var { options, label } = _a, props = __rest(_a, ["options", "label"]);
    const { getRootProps, getRadioProps } = useRadioGroup(props);
    const group = getRootProps();
    return (React.createElement(FormControl, null,
        label ? React.createElement(FormLabel, Object.assign({}, FormLabelStyle), label) : React.createElement(React.Fragment, null),
        React.createElement(Stack, Object.assign({}, group, { direction: "row", flexWrap: "wrap", gap: 2 }), options.map((_a, index) => {
            var { content } = _a, option = __rest(_a, ["content"]);
            const radio = getRadioProps({
                value: option.value,
                isChecked: option.isChecked,
            });
            return (React.createElement(ToggleButton, Object.assign({ key: index }, radio),
                React.createElement(Text, { fontSize: "xs", whiteSpace: "nowrap" }, content !== null && content !== void 0 ? content : capitalize(option.value))));
        }))));
};
const ToggleButton = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { getInputProps, getCheckboxProps } = useRadio(props);
    const input = getInputProps();
    const checkbox = getCheckboxProps();
    return (React.createElement(Box, { as: "label", flex: 1, marginInlineStart: "0px !important" },
        React.createElement("input", Object.assign({}, input)),
        React.createElement(Box, Object.assign({}, checkbox, { cursor: "pointer", borderWidth: "1px", borderRadius: "md", boxShadow: "md", _checked: {
                bg: "teal.600",
                color: "white",
                borderColor: "teal.600",
            }, _focus: {
                boxShadow: "outline",
            }, p: 1, textAlign: "center" }), children)));
};
